import React from 'react';
import ReactDOM from 'react-dom';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom'
import './index.scss';
import Notfound from './templates/Notfound';
import TplIndex from './templates/TplIndex';

const routes = (   
	<Router>
		<Switch>
      <Route exact path="/" component={TplIndex} />
      <Route path="/project/:slug" component={TplIndex} />
      <Route path="/article/:slug" component={TplIndex} /> 
			<Route path="/:slug" component={TplIndex} />           
			<Route component={Notfound} />
    </Switch>
      </Router> 
)

ReactDOM.render(routes, document.getElementById('root'));